export default __webpack_public_path__ + "static/media/bas-noir.2ced3213.svg";